import { z } from 'zod';
import { SearchTypes } from '@models/enums/components/Search/SearchTypes.enum';

export const SearchDataSchema = z.record(
  z.string(),
  z.record(z.string(), z.array(z.string()))
);

export const SearchSchema = z.object({
  hasSearch: z.boolean(),
  type: z.nativeEnum(SearchTypes),
  order: z.enum(['JSON', 'alphabetical']).optional(),
  fileData: z.record(z.string(), z.record(z.string(), z.array(z.string()))),
});
